<!--非首页-->
<template>
  <div>
    <div class="nav">
      <div
        style="
          margin: 0 auto;
          width: 1400px;
          display: flex;
          align-items: center;
          justify-content:space-between;
          height: 100%;
        "
      >
        <div class="logo-wrapper">
            <a href="/"><img style="width:350px" src="./../assets/images/logo_name.png" /></a>
        </div>
        <!-- {{this.isAdmin}} -->
        <!-- Login Start -->
        <div v-if="isAdmin">
          <el-dropdown trigger="click" v-if="userInfo" @command="logout">
            <span
              class="el-dropdown-link"
              style="color: rgba(255, 255, 255, 0.85)"
            >
              <el-button type="primary" class="reg-login">
                <span :title="userInfo" class="text">{{ userInfo }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="isAdmin" command="system"
                >联盟管理</el-dropdown-item
              >
              <el-dropdown-item command="toZhihuishu"
                >在线学堂</el-dropdown-item
              >
              <el-dropdown-item command="logout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button v-else class="reg-login" @click="toLogin">登录</el-button> -->
        </div>
        <div v-else></div>
        <!-- Login End -->
      </div>
    </div>
    <div class="nav-wrapper">
      <div style="width: 1400px; margin: 0 auto;display:flex;align-items:center;justify-content:space-between;">
        <router-link v-for="({ path, name }, i) in tabs" :to="path" :key="i-1">
          <span class="nav-item" :class="{ active: currentPath === path }">
            {{name}}
          </span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCookie,
  getLoginRealName,
  getLoginUserId,
  removeCookie,
  getLoginUUId,
} from "../plugins/cookie";
export default {
  inject: ["reload"],
  computed: {
    userInfo: function () {
      if (getCookie("CASLOGC")) {
        return getLoginRealName();
      }
      return "";
    },
    userId() {
      return getLoginUserId();
    },
    tabs() {
      return this.$store.state.tabs;
    },
    currentPath() {
      return this.$route.path;
    },
  },
  data() {
    return {
      isAdmin: false,
    };
  },
  created() {
    this.getLoginInfo();
  },
  methods: {
    // toLogin() {
    //   let url = window.location.href;
    //   url = encodeURI(url);
    //   window.location.href =
    //     "https://passport.zhihuishu.com/login?source=3&service=" + url;
    // },
    async logout(command) {

      switch (command) {
        case "system":
          window.open(
            `https://member.zhihuishu.com/userfore/1000/${getLoginUUId()}`
          );
          break;
        case "toZhihuishu":
          window.open(
            "https://onlineh5.zhihuishu.com/onlineWeb.html#/teachIndex"
          );
          break;
        case "logout":
          removeCookie("CASLOGC", ".zhihuishu.com");
          removeCookie("CASTGC", ".zhihuishu.com");
          self.$router.push("/");
      }
    },
    async getLoginInfo() {
      if (!getLoginUUId()) {
        this.isAdmin = false;
        return
      }else{
        this.isAdmin = true;
      }

      const res = await this.$get("userfore/getLoginInfo", {
        uuid: getLoginUUId(),
      });
      this.isAdmin = !!res.manageAuthor;
    },
  },
};
</script>
<style lang="scss" scoped>
.logo-wrapper {
  display: flex;
  align-items: center;
  // margin-right: 206px;
}
.logo {
  margin: 0 23px 0 0;
  display: inline-block;
  vertical-align: middle;
}
.logo img {
  width: 76px;
  height: 76px;
}
.font {
  font-size: 28px;
  color: #fff;
  line-height: 28px;
  letter-spacing: 1px;
}
.search-input {
  width: 280px;
  height: 48px;
  margin-right: 16px;
  .iconfont {
    display: inline-block;
    line-height: 48px;
    transform: translateX(-10px);
    cursor: pointer;
  }
  /deep/ .el-input__inner {
    background: rgba(1, 1, 1, 0.3);
    border-radius: 24px;
    border: 0;
    height: 48px;
    color: #fff;
  }
}

.reg-login {
  background: #fff;
  border-radius: 24px;
  color: #fff;
  border: 0;
  padding: 14px 24px;
  cursor: pointer;
  color: #2683FA;
  font-size: 16px;
  line-height: 20px;
  // max-width: 168px;
  .text {
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: 100px;
    vertical-align: bottom;
  }
}
.nav {
  height: 144px;
}
.nav-item {
  display: inline-block;
  font-size: 16px;
  color: #fff;
  line-height: 56px;
  min-width: 170px;
  text-align: center;
}
.nav-item.active {
  background: #1D4EB6;
}
.nav-wrapper {
  background:#1064D0;
}
.loginBtn{display:none;}
</style>
